<div class="header">
    <h1 mat-dialog-title>{{ data.title | translate }}</h1>
</div>
<div mat-dialog-content>
    <p class="dialog-message">{{ data.message | translate }}</p>
</div>
<div mat-dialog-actions class="button-class">
    <button class="btn btn-cancel" style="margin-right:10px;"
        (click)="cancel()">{{ data.cancelText | translate }}</button>
    <button class="btn btn-confirm" (click)="confirm()">{{ data.confirmText | translate }}</button>
</div>